import PropTypes from "prop-types"
import { BugAntIcon } from "@heroicons/react/24/outline"

ControlButton.propTypes = {
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  Icon: PropTypes.object.isRequired,
  tooltip: PropTypes.string.isRequired,
  iconOverrides: PropTypes.string,
}
export function ControlButton({
  onClick = () => {},
  onMouseEnter = () => {},
  onMouseLeave = () => {},
  Icon = BugAntIcon,
  tooltip = "Add a tooltip",
  iconOverrides = "",
}) {
  const customTheme = {
    arrow: {
      base: "absolute z-10 h-2 w-2 rotate-45",
      style: {
        dark: "bg-neutral-700",
      },
      placement: "-4px",
    },
    base: "absolute inline-block z-10 rounded-lg py-2 px-3 text-sm font-medium shadow-sm text-white",
    hidden: "invisible opacity-0",
    style: {
      dark: "text-white bg-neutral-700",
    },
    content: "relative z-20 w-fit",
  }

  return (
    <div className="flex items-center">
      <span className="sr-only">{tooltip}</span>
      <button
        type="button"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Icon className={`h-6 w-6 text-gray-500 transition hover:text-gray-300 ${iconOverrides}`} />
      </button>
    </div>
  )
}
